<!-- <app-cube-loader></app-cube-loader> -->

<nav
  class="navbar navbar-expand-lg floating-navbar"
  [class.hidden]="hideLayout"
>
  <div class="container-fluid">
    <a class="navbar-brand" routerLink="/">
      <img [src]="images.website_logo" alt="logo" class="logo-img" />
    </a>

    <div class="exchange-rate-display d-none d-lg-flex">
      <div class="exchange-rate-icon">
        <svg
          height="20px"
          viewBox="0 -960 960 960"
          width="20px"
          fill="currentColor"
        >
          <path
            d="M480-40q-112 0-206-51T120-227v107H40v-240h240v80h-99q48 72 126.5 116T480-120q75 0 140.5-28.5t114-77q48.5-48.5 77-114T840-480h80q0 91-34.5 171T791-169q-60 60-140 94.5T480-40Zm-36-160v-52q-47-11-76.5-40.5T324-370l66-26q12 41 37.5 61.5T486-314q33 0 56.5-15.5T566-378q0-29-24.5-47T454-466q-59-21-86.5-50T340-592q0-41 28.5-74.5T446-710v-50h70v50q36 3 65.5 29t40.5 61l-64 26q-8-23-26-38.5T482-648q-35 0-53.5 15T410-592q0 26 23 41t83 35q72 26 96 61t24 77q0 29-10 51t-26.5 37.5Q583-274 561-264.5T514-250v50h-70ZM40-480q0-91 34.5-171T169-791q60-60 140-94.5T480-920q112 0 206 51t154 136v-107h80v240H680v-80h99q-48-72-126.5-116T480-840q-75 0-140.5 28.5t-114 77q-48.5 48.5-77 114T120-480H40Z"
          />
        </svg>
      </div>
      <div class="exchange-rate-content">
        <span class="exchange-rate-label">USD → PHP</span>
        <span class="exchange-rate-value">
          <span class="currency-symbol"></span>{{ exchangeRate || "..." }}
        </span>
      </div>
      <div class="exchange-rate-indicator">
        <span class="live-badge">
          <span class="live-dot"></span>
          LIVE
        </span>
      </div>
    </div>

    <button
      class="navbar-toggler"
      type="button"
      (click)="toggleNavbar()"
      [attr.aria-expanded]="isNavbarCollapsed ? 'false' : 'true'"
      aria-controls="mainNavbar"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
      <span class="hamburger-line"></span>
    </button>

    <div
      class="collapse navbar-collapse"
      [class.show]="!isNavbarCollapsed"
      id="mainNavbar"
    >
      <div class="exchange-rate-mobile d-lg-none">
        <div class="exchange-rate-icon">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="20px"
            viewBox="0 -960 960 960"
            width="20px"
            fill="currentColor"
          >
            <path
              d="M480-40q-112 0-206-51T120-227v107H40v-240h240v80h-99q48 72 126.5 116T480-120q75 0 140.5-28.5t114-77q48.5-48.5 77-114T840-480h80q0 91-34.5 171T791-169q-60 60-140 94.5T480-40Zm-36-160v-52q-47-11-76.5-40.5T324-370l66-26q12 41 37.5 61.5T486-314q33 0 56.5-15.5T566-378q0-29-24.5-47T454-466q-59-21-86.5-50T340-592q0-41 28.5-74.5T446-710v-50h70v50q36 3 65.5 29t40.5 61l-64 26q-8-23-26-38.5T482-648q-35 0-53.5 15T410-592q0 26 23 41t83 35q72 26 96 61t24 77q0 29-10 51t-26.5 37.5Q583-274 561-264.5T514-250v50h-70ZM40-480q0-91 34.5-171T169-791q60-60 140-94.5T480-920q112 0 206 51t154 136v-107h80v240H680v-80h99q-48-72-126.5-116T480-840q-75 0-140.5 28.5t-114 77q-48.5 48.5-77 114T120-480H40Z"
            />
          </svg>
        </div>
        <div class="exchange-rate-content">
          <span class="exchange-rate-label">USD → PHP</span>
          <span class="exchange-rate-value">
            <span class="currency-symbol"></span>{{ exchangeRate || "..." }}
          </span>
        </div>
        <div class="exchange-rate-indicator">
          <span class="live-badge">
            <span class="live-dot"></span>
            LIVE
          </span>
        </div>
      </div>

      <ul class="navbar-nav ms-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/home"
            [class.active]="isActive('/home')"
            (click)="closeNavbar()"
            >Home</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/ship-a-box"
            [class.active]="isActive('/ship-a-box')"
            (click)="closeNavbar()"
            >Ship a Box</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/remit"
            [class.active]="isActive('/remit')"
            (click)="closeNavbar()"
            >Remit</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/branches"
            [class.active]="isActive('/branches')"
            (click)="closeNavbar()"
            >Branches</a
          >
        </li>
        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/track"
            [class.active]="isActive('/track')"
            (click)="closeNavbar()"
            >Track</a
          >
        </li>

        <li class="nav-item">
          <a
            class="nav-link"
            routerLink="/contact-us"
            [class.active]="isActive('/contact-us')"
            (click)="closeNavbar()"
            >Contact Us</a
          >
        </li>

        <li
          class="nav-item dropdown"
          *ngIf="currUser | async; else elseTemplate"
        >
          <a
            class="nav-link dropdown-toggle"
            href="#"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {{ (currUser | async)?.firstName }}
            {{ (currUser | async)?.lastName }}
          </a>
          <ul class="dropdown-menu">
            <li *ngIf="currUser | async">
              <a class="dropdown-item" routerLink="/transaction-history"
                >TRANSACTION HISTORY</a
              >
            </li>
            <li>
              <a class="dropdown-item" (click)="logout()" routerLink="#"
                >LOGOUT</a
              >
            </li>
          </ul>
        </li>
        <ng-template #elseTemplate>
          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/login"
              [class.active]="isActive('/login')"
              >Login</a
            >
          </li>

          <li class="nav-item">
            <a
              class="nav-link"
              routerLink="/register"
              [class.active]="isActive('/register')"
              >Register</a
            >
          </li>
        </ng-template>
      </ul>
    </div>
  </div>
</nav>

<div class="app-container">
  <app-ai-agent></app-ai-agent>
  <router-outlet></router-outlet>
</div>

<!-- START FOOTER -->
<footer class="footer bg-light pt-5" [class.hidden]="hideLayout">
  <div class="container pb-4">
    <div class="row gy-4">
      <div class="col-lg-3 col-md-6">
        <img [src]="images.website_logo" alt="" class="mb-2" />
        <p class="text-muted small">
          Finally! Your one-stop shop for all your Balikbayan needs!
        </p>
      </div>
      <div class="col-lg-1 col-md-6"></div>

      <div class="col-lg-2 col-md-6">
        <h6 class="fw-bold mb-3">Quick Links</h6>
        <ul class="list-unstyled footer-links">
          <li><a href="/ship-a-box">Balikbayan Box</a></li>
          <li><a href="/remit">Money Remittance</a></li>
          <li><a href="/branches">Branches</a></li>
          <!-- <li><a href="#">Services</a></li> -->
        </ul>
      </div>

      <div class="col-lg-2 col-md-6">
        <h6 class="fw-bold mb-3">‎</h6>
        <ul class="list-unstyled footer-links">
          <!-- <li><a href="#">Blogs</a></li>
          <li><a href="#">About us</a></li>
          <li><a href="#">Contact us</a></li> -->
          <li><a href="/transaction-history">Transaction History</a></li>
          <li><a href="/account-deactivation">Account Deactivation</a></li>
          <li *ngIf="!isAuthBtnShown">
            <a (click)="logout()" href="#">Logout</a>
          </li>
        </ul>
      </div>

      <div class="col-lg-2 col-md-6">
        <h6 class="fw-bold mb-3">Partner</h6>
        <ul class="list-unstyled footer-links">
          <li><a href="https://www.my7107.com/">7107 Islands</a></li>
          <li><a href="https://www.abxpinc.com/">ABXP</a></li>
          <!-- <li><a href="#">Jolong Enterprises</a></li> -->
          <li><a href="https://logoremit.com/">LOGO Remittance</a></li>
          <!-- <li><a href="https://www.metrobank.com.ph/home">Metrobank</a></li>
          <li><a href="https://uniteller.com/">Uniteller</a></li> -->
        </ul>
      </div>

      <div class="col-lg-2 col-md-6">
        <h6 class="fw-bold mb-3">Resources</h6>
        <ul class="list-unstyled footer-links">
          <!-- <li><a href="#">Support</a></li> -->
          <!-- <li><a href="#">Securities</a></li>
          <li><a href="#">Help center</a></li>
          <li><a href="#">Preferences</a></li> -->
          <li><a href="/terms-and-conditions">Term & legals</a></li>
          <!-- <li><a href="#">Privacy policy</a></li> -->
        </ul>
      </div>
    </div>

    <hr class="my-4" />

    <div
      class="d-flex flex-column flex-md-row justify-content-between align-items-center"
    >
      <p class="text-muted small mb-2 mb-md-0">
        Copyright &copy; 2021 Longares Global Operations, Inc.
      </p>
      <div class="d-flex gap-3">
        <a href="https://www.instagram.com/mylogoinc/" class="text-muted"
          ><i class="bi bi-instagram"></i
        ></a>
        <a href="https://www.youtube.com/@LOGOCargoYT" class="text-muted"
          ><i class="bi bi-youtube"></i
        ></a>
        <a href="https://www.facebook.com/LOGOinc.USA" class="text-muted"
          ><i class="bi bi-facebook"></i
        ></a>
        <a href="mailto:cs@logocargo.com" class="text-muted">
          <i class="bi bi-envelope"></i>
        </a>
        <a href="https://www.tiktok.com/@logotvkababayan" class="text-muted"
          ><i class="bi bi-tiktok"></i
        ></a>
      </div>
    </div>
  </div>
</footer>
<!-- END FOOTER -->

<script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.0/dist/js/bootstrap.bundle.min.js"></script>
